//附件
import React, { Component } from 'react';
import { Drawer } from 'antd';


//第一章
import Enclosure01 from './component/Enclosure01.js';
import Enclosure02 from './component/Enclosure02.js';

//第二章
import Enclosure21 from './component/Enclosure21.js';  //云豪学院课程级证书分类导图
import Enclosure22 from './component/Enclosure22.js';  //动态积分的设定内容

//第三章
import Enclosure31 from './component/Enclosure31.js';
import Enclosure32 from './component/Enclosure32.js';
import Enclosure33 from './component/Enclosure33.js';  //员工手册
import Enclosure34 from './component/Enclosure34.js';  //劳务人员面试登记表
import Enclosure35 from './component/Enclosure35.js';  //新员工入职告知书
import Enclosure36 from './component/Enclosure36.js';  //入职声明书
import Enclosure37 from './component/Enclosure37.js';  //新员工入职指引手册
import Enclosure38 from './component/Enclosure38.js';  //员工离职审批表
import Enclosure39 from './component/Enclosure39.js';  //员工离职交接表
import Enclosure310 from './component/Enclosure310.js';  //员工离职面谈表
import Enclosure311 from './component/Enclosure311.js';  //离职员工离职证明
import Enclosure312 from './component/Enclosure312.js';  //解除劳动合同通知书
import Enclosure313 from './component/Enclosure313.js';  //续订劳动合同通知书
import Enclosure314 from './component/Enclosure314.js';  //解除劳动合同协议
import Enclosure315 from './component/Enclosure315.js';  //岗位责任及收入分配协定书
import Enclosure318 from './component/Enclosure318.js';  //云豪精品
import Enclosure319 from './component/Enclosure319.js';  //合同签署户别
import Enclosure320 from './component/Enclosure320.js';  //员工停薪留职申请表
import Enclosure321 from './component/Enclosure321.js';  //停薪留职协议

// import Enclosure316 from './component/Enclosure316.js';  //试用期员工转正考核表
// import Enclosure317 from './component/Enclosure317.js';  //试用期员工转正试题

//第四章
import Enclosure41 from './component/Enclosure41.js';  //《云豪集团安全生产事故（事件）处理规则》
import Enclosure42 from './component/Enclosure42.js';  //《云豪集团交通事故处理办法》
import Enclosure43 from './component/Enclosure43.js';  //《云豪集团安全小组名单》

//第五章
import Enclosure51 from './component/Enclosure51.js';  //《云豪集团2020年报销审批流程表》

//第六章
import Enclosure61 from './component/Enclosure61.js';  //《云豪集团各部门月会周会晨夕会统计表》
import Enclosure62 from './component/Enclosure62.js';  //《会议纪要模板》
import Enclosure63 from './component/Enclosure63.js';  //《云豪车服各部室职能及岗位职责》
import Enclosure64 from './component/Enclosure64.js';  //《配件业务管理公司内部管控细则》
import Enclosure65 from './component/Enclosure65.js';  //《配件营销绩效方案细则》
import Enclosure66 from './component/Enclosure66.js';  //《电商中心人员岗位职责》
import Enclosure67 from './component/Enclosure67.js';  //《报价函》
import Enclosure68 from './component/Enclosure68.js';  //《客户拜访表——牵引及服务销售》
import Enclosure69 from './component/Enclosure69.js';  //《客户拜访表——专用车》
import Enclosure610 from './component/Enclosure610.js';  //《销售进程看板》
import Enclosure611 from './component/Enclosure611.js';  //《成交客户信息交接单》
import Enclosure612 from './component/Enclosure612.js';  //《市场部作业流程及标准》
import Enclosure613 from './component/Enclosure613.js';  //《销售支持科业务流程及标准》
import Enclosure614 from './component/Enclosure614.js';  //《海外业务管理公司统计部业务流程细则》
import Enclosure615 from './component/Enclosure615.js';  //《海外业务管理公司整车业务流程》
import Enclosure616 from './component/Enclosure616.js';  //《海外业务管理公司上装业务流程》
import Enclosure617 from './component/Enclosure617.js';  //《二手车事业部二手车业务流程》
import Enclosure618 from './component/Enclosure618.js';  //《贸促会注册、产地证申领流程》
import Enclosure619 from './component/Enclosure619.js';  //《尼日利亚PC办理流程》
import Enclosure620 from './component/Enclosure620.js';  //《2020年云豪备品出口业务流程及相关岗位职责（试行版）》
import Enclosure621 from './component/Enclosure621.js';  //《海外业务管理公司外贸业务流程细则》
import Enclosure622 from './component/Enclosure622.js';  //《海外分公司驻外员工回调申请表》
import Enclosure623 from './component/Enclosure623.js';  //《海外人员招聘需求表》
import Enclosure624 from './component/Enclosure624.js';  //《海外公司驻外人员管理细则》
import Enclosure625 from './component/Enclosure625.js';  //《云豪集团驻外人员派遣协议书》
import Enclosure626 from './component/Enclosure626.js';  //《海外公司“三会三报”管理细则 Overseas companies' three meetings and three reports management rules》
import Enclosure627 from './component/Enclosure627.js';  //《交车流程及执行标准》
import Enclosure628 from './component/Enclosure628.js';  //《国产车接车检查单》
import Enclosure629 from './component/Enclosure629.js';  //《国产车交车检查单》
import Enclosure630 from './component/Enclosure630.js';  //《国产车信息汇总表（交车信息表、库存表、应收账款）》xinyuzijin
import Enclosure631 from './component/Enclosure631.js';  //《销售政策（价格）制定流程》
import Enclosure632 from './component/Enclosure632.js';  //《信誉资金、临时授信投放流程》
import Enclosure633 from './component/Enclosure633.js';  //《续签月结合同签订流程》
import Enclosure634 from './component/Enclosure634.js';  //《备品销售政策》

//第九章
import Enclosure09 from './component/Enclosure09.js';  //《云豪集团讲师申请表》
import Enclosure91 from './component/Enclosure91.js';  //《外部讲师聘用流程表》
import Enclosure92 from './component/Enclosure92.js';  //《培训效果评估表》

//第十章
import Enclosure101 from './component/Enclosure101.js';  //《销售支持科业务流程及标准》



class Index extends Component {
    
    state = {
        visible:false,
        title:'',
        //标识
        dataSign :'',
    }
    
    componentWillReceiveProps(nextProps){
        this.setState({
            visible:nextProps.visible,
            title:nextProps.title,
        })

        //点击的附件id  nextProps.id
        let a = [];
        a.push(nextProps.id);
        this.setState({dataSign :a[0]});
    }

    onClose = () => {
        this.props.enclosureClose();
    }

    render(){

        const { title,visible,dataSign  } = this.state;
        return(
            <div>
                <Drawer
                    title={title}
                    placement="right"
                    closable={false}
                    keyboard={false}
                    onClose={this.onClose}
                    width='60%'
                    visible={visible}
                    >
                    <div>
                        {dataSign === "Enclosure01" && <Enclosure01 />}
                        {dataSign === "Enclosure0_2" && <Enclosure02 />}

                        {dataSign === "Enclosure21" && <Enclosure21/>}
                        {dataSign === "Enclosure22" && <Enclosure22/>}

                        {dataSign === "Enclosure31" && <Enclosure31/>}
                        {dataSign === "Enclosure32" && <Enclosure32/>}
                        {dataSign === "Enclosure33" && <Enclosure33/>}
                        {dataSign === "Enclosure34" && <Enclosure34/>}
                        {dataSign === "Enclosure35" && <Enclosure35/>}
                        {dataSign === "Enclosure36" && <Enclosure36/>}
                        {dataSign === "Enclosure37" && <Enclosure37/>}
                        {dataSign === "Enclosure38" && <Enclosure38/>}
                        {dataSign === "Enclosure39" && <Enclosure39/>}
                        {dataSign === "Enclosure310" && <Enclosure310/>}
                        {dataSign === "Enclosure311" && <Enclosure311/>}
                        {dataSign === "Enclosure312" && <Enclosure312/>}
                        {dataSign === "Enclosure313" && <Enclosure313/>}
                        {dataSign === "Enclosure314" && <Enclosure314/>}
                        {dataSign === "Enclosure315" && <Enclosure315/>}
                        {/* {dataSign === "Enclosure316" && <Enclosure316/>}
                        {dataSign === "Enclosure317" && <Enclosure317/>} */}
                        {dataSign === "Enclosure318" && <Enclosure318/>}
                        {dataSign === "Enclosure319" && <Enclosure319/>}
                        {dataSign === "Enclosure320" && <Enclosure320/>}
                        {dataSign === "Enclosure321" && <Enclosure321/>}

                        {dataSign === "Enclosure41" && <Enclosure41/>}
                        {dataSign === "Enclosure42" && <Enclosure42/>}
                        {dataSign === "Enclosure43" && <Enclosure43/>}

                        {dataSign === "Enclosure51" && <Enclosure51/>}

                        {dataSign === "Enclosure61" && <Enclosure61/>}
                        {dataSign === "Enclosure62" && <Enclosure62/>}
                        {dataSign === "Enclosure63" && <Enclosure63/>}
                        {dataSign === "Enclosure64" && <Enclosure64/>}
                        {dataSign === "Enclosure65" && <Enclosure65/>}
                        {dataSign === "Enclosure66" && <Enclosure66/>}
                        {dataSign === "Enclosure67" && <Enclosure67/>}
                        {dataSign === "Enclosure68" && <Enclosure68/>}
                        {dataSign === "Enclosure69" && <Enclosure69/>}
                        {dataSign === "Enclosure610" && <Enclosure610/>}
                        {dataSign === "Enclosure611" && <Enclosure611/>}
                        {dataSign === "Enclosure612" && <Enclosure612/>}
                        {dataSign === "Enclosure613" && <Enclosure613/>}
                        {dataSign === "Enclosure614" && <Enclosure614/>}
                        {dataSign === "Enclosure615" && <Enclosure615/>}
                        {dataSign === "Enclosure616" && <Enclosure616/>}
                        {dataSign === "Enclosure617" && <Enclosure617/>}
                        {dataSign === "Enclosure618" && <Enclosure618/>}
                        {dataSign === "Enclosure619" && <Enclosure619/>}
                        {dataSign === "Enclosure620" && <Enclosure620/>}
                        {dataSign === "Enclosure621" && <Enclosure621/>}
                        {dataSign === "Enclosure622" && <Enclosure622/>}
                        {dataSign === "Enclosure623" && <Enclosure623/>}
                        {dataSign === "Enclosure624" && <Enclosure624/>}
                        {dataSign === "Enclosure625" && <Enclosure625/>}
                        {dataSign === "Enclosure626" && <Enclosure626/>}
                        {dataSign === "Enclosure627" && <Enclosure627/>}
                        {dataSign === "Enclosure628" && <Enclosure628/>}
                        {dataSign === "Enclosure629" && <Enclosure629/>}
                        {dataSign === "Enclosure630" && <Enclosure630/>}
                        {dataSign === "Enclosure631" && <Enclosure631/>}
                        {dataSign === "Enclosure632" && <Enclosure632/>}
                        {dataSign === "Enclosure633" && <Enclosure633/>}
                        {dataSign === "Enclosure634" && <Enclosure634/>}

                        {dataSign === "Enclosure09" && <Enclosure09/>}
                        {dataSign === "Enclosure91" && <Enclosure91/>}
                        {dataSign === "Enclosure92" && <Enclosure92/>}

                        {dataSign === "Enclosure101" && <Enclosure101/>}

                    </div>
                        
                </Drawer>
                
                
            </div>
        )
    }
}

export default Index;